<template>
    <div class="space-y-6 mt-6">
        <!-- Header -->
        <div
            class="flex flex-col lg:flex-row lg:items-center lg:justify-between"
        >
            <div>
                <h1 class="text-3xl font-bold text-theme-primary">
                    ¡Hola, {{ user.name }} 👋
                </h1>

                <p class="mt-2 text-theme-base">
                    Bienvenido nuevamente. Aquí tienes un resumen de tu
                    catálogo.
                </p>
            </div>
        </div>

        <plan-upgrade-card
            :subscription="subscription"
            :products-unlocked="productsUnlocked"
            @see-plans="goToPlans"
        />

        <div
            class="grid grid-cols-1 gap-6"
            :class="canViewCatalogPreview ? 'lg:grid-cols-5' : ''"
        >
            <app-tools
                class="order-last lg:order-first"
                :class="canViewCatalogPreview ? 'lg:col-span-3' : ''"
            />
            <div class="order-first lg:order-last lg:col-span-2">
                <catalog-preview-card
                    v-if="canViewCatalogPreview"
                    collapsible
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import CatalogPreviewCard from "@/components/editor/CatalogPreviewCard.vue";
import AppTools from "@/components/utils/AppTools.vue";
import PlanUpgradeCard from "@/components/utils/PlanUpgradeCard.vue";

export default {
    name: "AppIndex",
    components: {
        AppTools,
        CatalogPreviewCard,
        PlanUpgradeCard
    },
    computed: {
        ...mapState("auth", [
            "user",
            "tenantId",
            "featureFlags",
            "subscription"
        ]),
        productsUnlocked() {
            return !!this.featureFlags?.productsUnlocked;
        },
        canViewNotifications() {
            return (
                !!this.tenantId &&
                this.$ability.hasPermission("notification:List")
            );
        },
        canViewCatalogPreview() {
            return this.$ability.hasPermission("page:GetCatalog");
        }
    },

    watch: {},
    async mounted() {
        if (this.canViewNotifications) {
            this.listNotificationsComponent(true);
        }
        this.reloadMerchantPermissions();
    },
    methods: {
        ...mapActions("notifications", ["listNotifications"]),
        ...mapActions("auth", ["reloadMerchantPermissions"]),
        goToPlans(path) {
            this.$router.push(path);
        },

        async listNotificationsComponent(required = false) {
            try {
                await this.listNotifications({ required });
            } catch (error) {
                console.error(error);
            }
        }
    }
};
</script>
